import React, { useState, useEffect } from 'react';
import "./AdminPanel.css";
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import AdminSidebar from "./AdminSidebar";
import AdministratorSidebar from "./AdministratorSidebar";
import UserSidebar from "./UserSidebar";

const Banner = () => {
    const navigate = useNavigate();
    const [userType, setUserType] = useState("");
    const [userName, setUserName] = useState("");
    const [userFullName, setUserFullName] = useState("");
    const [cars, setCars] = useState([]);
    const [error, setError] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [highlightStatus, setHighlightStatus] = useState({});
    const itemsPerPage = 10;

    useEffect(() => {
        // Get user data from localStorage
        const storedUserType = localStorage.getItem("usertype");
        const storedUserName = localStorage.getItem("userName");
        const storedFName = localStorage.getItem("fname");
        const storedLName = localStorage.getItem("lname");

        console.log(storedUserType); // Log to ensure it's retrieved correctly
        if (!storedUserType) {
            navigate("/login"); // Redirect if not logged in
        } else {
            setUserType(storedUserType);
            setUserName(storedUserName);
            // Combine first and last name if available
            if (storedFName && storedLName) {
                setUserFullName(`${storedFName} ${storedLName}`);
            } else if (storedFName) {
                setUserFullName(storedFName);
            } else {
                setUserFullName(storedUserName);
            }
        }
    }, [navigate]);

    // Logout function
    const logout = () => {
        // Clear session data from localStorage
        localStorage.removeItem("token");
        localStorage.removeItem("email");
        localStorage.removeItem("userName");
        localStorage.removeItem("usertype");
        localStorage.removeItem("fname");
        localStorage.removeItem("lname");

        // Redirect to login page after logout
        navigate("/login");
    };

    useEffect(() => {
        fetchCars();
    }, []);

    const fetchCars = async () => {
        try {
            const response = await axios.get('https://api.mitradingjp.com/get-car-banner.php');
            console.log('API Response:', response.data); // Debug the response
            // Ensure response.data is an array before setting state
            if (Array.isArray(response.data)) {
                setCars(response.data);
                setError(null);
            } else {
                console.error('API did not return an array:', response.data);
                setCars([]);
                setError(response.data.error || 'Failed to load vehicles: Invalid API response');
            }
        } catch (error) {
            console.error('Error fetching cars:', error);
            setCars([]);
            setError('Failed to load vehicles: Network or server error');
        }
    };

    useEffect(() => {
        if (cars.length > 0) {
            const stockIds = cars.map(car => car.stock_id).join(',');
            const fetchHighlight = async () => {
                try {
                    const response = await axios.get(`https://api.mitradingjp.com/check_highlight.php?stock_ids=${stockIds}`);
                    setHighlightStatus(response.data);
                } catch (error) {
                    console.error('Error fetching highlight status:', error);
                }
            };
            fetchHighlight();
        }
    }, [cars]);

    const handleEdit = (id) => {
        navigate(`/edit-banner/${id}`);
    };

    const handleAllocate = (stock_id) => {
        navigate(`/allocate-vehicle/${stock_id}`);
    };

    const handleImageClick = (id) => {
        navigate(`/vehicle-images/${id}`);
    };

    const handleViewDocs = (id) => {
        navigate(`/view-docs/${id}`);
    };

    const handleDelete = async (id) => {
        try {
            // Confirm deletion with the user
            const confirmDelete = window.confirm('Are you sure you want to delete this car?');
            if (!confirmDelete) return;

            // Send a DELETE request to the backend
            const response = await axios.delete(`https://api.mitradingjp.com/delete_car_banner?id=${id}`);

            // Log the response for debugging
            console.log('Delete response:', response.data);

            // Display a success message
            if (response.data.message) {
                alert(response.data.message); // Show success message
            } else if (response.data.error) {
                alert(response.data.error); // Show error message
            }

            // Refresh the car list after deletion
            fetchCars();
            // Reset to first page if the current page becomes empty
            const totalPages = Math.ceil(cars.length / itemsPerPage);
            if (currentPage > totalPages && totalPages > 0) {
                setCurrentPage(totalPages);
            }
        } catch (error) {
            console.error('Error deleting car:', error);
            alert('An error occurred while deleting the car. Please check the console for details.');
        }
    };

    const handleInvoice = (id) => {
        navigate(`/invoice/${id}`);
    };

    // Pagination logic
    const totalItems = cars.length;
    const totalPages = Math.ceil(totalItems / itemsPerPage);
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    const currentCars = cars.slice(startIndex, endIndex);

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
        window.scrollTo(0, 0); // Scroll to top on page change
    };

    return (
        <div className="admin-container">
            {/* Conditionally Render Sidebar */}
            <div className="sidebar-container">
                {userType === "administrator" && <AdministratorSidebar />}
                {userType === "admin" && <AdminSidebar />}
                {userType === "user" && <UserSidebar />}
            </div>

            <div className="admin-content">
                <div className="adminnavbar">
                    <h1>Welcome to the Admin Panel, {userFullName}</h1>
                    {/* Logout button */}
                    <button onClick={logout} className="logoutbtn">
                        Logout
                    </button>
                </div>

                <div className="mainsection">
                    <h3>View All Banner Lists</h3>
                </div>

                <div className="container">
                    {error && (
                        <div className="alert alert-danger" role="alert">
                            {error}
                        </div>
                    )}
                    <table className="table table-striped">
                        <thead>
                            <tr>
                              <th style={{ textAlign: "center" }}>ID</th>
                              <th style={{ textAlign: "center" }}>Name</th>
                              <th style={{ textAlign: "center" }}>Image</th>
                              <th style={{ textAlign: "center" }}>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentCars.length > 0 ? (
                                currentCars.map((data) => (
                                    <tr key={data.id}>
                                        <td style={{ textAlign: "center" }}>{data.id}</td>
                                        <td style={{ textAlign: "center" }}>{data.name}</td>
                                        <td style={{ textAlign: "center" }}>
                                            <img
                                                src={`https://api.mitradingjp.com/${data.image_path}`}
                                                alt="Car"
                                                style={{ width: '90px', height: 'auto', cursor: 'pointer', border:highlightStatus[data.id] ? '7px solid #0d6efd' : 'transparent' }}
                                                onClick={() => handleImageClick(data.id)}
                                            />
                                        </td>
                                        
                                        <td style={{ textAlign: "center" }}>
                                            <span title="Edit">
                                                <svg xmlns="http://www.w3.org/2000/svg" onClick={() => handleEdit(data.id)} style={{ color: "#ffffff", marginRight: "10px", backgroundColor: "#0168FA", padding: "3px" }} width="20" height="20" alt="Edit" fill="currentColor" className="bi bi-pencil-square" viewBox="0 0 16 16">
                                                    <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                                                    <path fillRule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z" />
                                                </svg>
                                            </span>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="8" style={{ textAlign: "center", padding: "20px" }}>
                                        {error ? 'Error loading vehicles' : 'No vehicles found'}
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>

                    {/* Pagination Controls */}
                    {totalItems > itemsPerPage && (
                        <nav aria-label="Page navigation">
                            <ul className="pagination justify-content-center">
                                <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                    <button
                                        className="page-link"
                                        onClick={() => handlePageChange(currentPage - 1)}
                                        disabled={currentPage === 1}
                                    >
                                        Previous
                                    </button>
                                </li>

                                {[...Array(totalPages).keys()].map(page => (
                                    <li
                                        key={page + 1}
                                        className={`page-item ${currentPage === page + 1 ? 'active' : ''}`}
                                    >
                                        <button
                                            className="page-link"
                                            onClick={() => handlePageChange(page + 1)}
                                        >
                                            {page + 1}
                                        </button>
                                    </li>
                                ))}

                                <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                    <button
                                        className="page-link"
                                        onClick={() => handlePageChange(currentPage + 1)}
                                        disabled={currentPage === totalPages}
                                    >
                                        Next
                                    </button>
                                </li>
                            </ul>
                        </nav>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Banner;